import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Solicitud } from '../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from '../../interfaces/interface-bakend/response';
import { Payments } from '../../interfaces/interface-bakend/payments/payments.interfaces';
import { SignoSedeSearch } from '@interfaces/interface-bakend/cartilla/cartilla.interface';
import { SignoCentroMedico } from '@interfaces/interface-bakend/entidades/signo-centro-medico.interface';

const URL_BACKEND = environment.urlBackend;

@Injectable({
  providedIn: 'root'
})
export class CartillaService {

  constructor(
      private authService: AuthService,
      private httpClient: HttpClient,
  ) { }

  async getBusquedaNomenclador(data: SignoSedeSearch): Promise<SignoCentroMedico[]> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/busquedaNomenclador`, data , { headers }).subscribe( resp => {
            console.log('resp', resp);
            resolve(resp.response);
        }, error => {
            console.log('error', error);
        });
    });
  }

  async getZonasDisponibles(data: SignoSedeSearch): Promise<string[]> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/zonasDisponibles`, data , { headers }).subscribe( resp => {
            resolve(resp.response || []);
        }, error => {
            console.log('error', error);
            resolve([]);
        });
    });
  }

  async getZonaPorCoordenadas(latitud: number, longitud: number): Promise<{ zona: string | null }> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/zonaPorCoordenadas`, { latitud, longitud } , { headers }).subscribe( resp => {
            resolve(resp.response || { zona: null });
        }, error => {
            console.log('error', error);
            resolve({ zona: null });
        });
    });
  }

  async getRubrosDisponibles(data: SignoSedeSearch): Promise<string[]> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/rubrosDisponibles`, data , { headers }).subscribe( resp => {
            resolve(resp.response || []);
        }, error => {
            console.log('error', error);
            resolve([]);
        });
    });
  }

  async getEspecialidadesDisponibles(data: SignoSedeSearch): Promise<string[]> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/especialidadesDisponibles`, data , { headers }).subscribe( resp => {
            resolve(resp.response || []);
        }, error => {
            console.log('error', error);
            resolve([]);
        });
    });
  }

  async getLocalidadesDisponibles(data: SignoSedeSearch): Promise<string[]> {
    const headers =  new HttpHeaders({
        'x-token': await this.authService.loadJwToken(),
    });

    return new Promise( resolve => {
        this.httpClient.post<Response>(`${ URL_BACKEND }/signo-centros/localidadesDisponibles`, data , { headers }).subscribe( resp => {
            resolve(resp.response || []);
        }, error => {
            console.log('error', error);
            resolve([]);
        });
    });
  }

}
